import Vue from 'vue'
import Vuex from 'vuex';
import Components from './components';
import WokComponents from 'wok-components/src/index';
import WokForms from 'wok-forms';
import VueCompositionApi from "@vue/composition-api";
import appSettings from '../appsettings.json';
import { init as initOidc } from './oidc';
import { init as initApi } from './helpers/api';
import { filters } from './helpers/filters';
import { getStore } from './store';
import { init as initRouter } from './router';
import { init as initI18n } from './i18n';
import { initMediaModule } from './helpers/media';
import { initDetector } from './helpers/detector';
import App from './App.vue';

const settings = (<any>appSettings)[window.location.hostname];

initOidc(options => {
    options.userManagerSettings = settings.oidc;
})

window.onload = async function () {
    initApi(options => {
        options.useOidc = true;
    })

    Vue.mixin({ filters });

    Vue.config.productionTip = false;
    Vue.use(VueCompositionApi);
    Vue.use(Vuex);
    Vue.use(Components);
    Vue.use(WokComponents);
    Vue.use(WokForms);

    let store = getStore();
    store.registerModule('media', initMediaModule());

    initDetector((level) => {
        store.commit('setMobile', level >= 1);
    });

    new Vue({
    store,
    router: initRouter(),
    i18n: initI18n(),
    render: h => h(App)
    }).$mount('#app')
};

// Generate CSS
import './styles/main.pcss';